export const IS_DEV = /localhost/gi.test(window.location.hostname);
export const API_URL = process.env.REACT_APP_API_URL;
